import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentManagementRoutingModule } from './document-management-routing.module';
import { DocumentManagementDashboardComponent } from './pages/document-management-dashboard/document-management-dashboard.component';
import { UploadPanelComponent } from './components/upload-panel/upload-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormModule } from '../core/components/dynamic-form/dynamic-form.module';
import { CommonTLFModule } from '../common/common.module';
import { DocumentStatusCardComponent } from './components/document-status-card/document-status-card.component';
import { StatusLabelComponent } from './components/status-label/status-label.component';
import {
  DocumentManagementDettaglioComponent
} from './pages/document-management-dettaglio/document-management-dettaglio.component';
import {DocumentActionsCardComponent} from './components/document-actions-card/document-actions-card.component';
import {DocumentFilterComponent} from './components/document-filter/document-filter.component';
import { DocumentDetailTabsComponent } from './components/document-detail-tabs/document-detail-tabs.component';
import { DocumentAssModalComponent } from './components/modals/document-ass-modal/document-ass-modal.component';
import { ModalMetadataComponent } from './components/document-actions-card/modal-metadata/modal-metadata/modal-metadata.component';
import { SuggestedPracticesComponent } from './components/suggested-practices/suggested-practices.component';

@NgModule({
  declarations: [
    DocumentManagementDashboardComponent,
    UploadPanelComponent,
    DocumentStatusCardComponent,
    StatusLabelComponent,
    DocumentManagementDettaglioComponent,
    DocumentActionsCardComponent,
    DocumentFilterComponent,
    DocumentDetailTabsComponent,
    DocumentAssModalComponent,
    ModalMetadataComponent,
    SuggestedPracticesComponent,
  ],
  imports: [
    CommonModule,
    CommonTLFModule,
    DocumentManagementRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
  ]
})
export class DocumentManagementModule { }
